
/* INT: Pre-decode iOS OOM guard v2 — src setter intercept */
(function() {
  if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) return;

  var _active = false;
  var _origSrc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
  var _origSetAttr = Element.prototype.setAttribute;

  function isOffSlide(el) {
    var slide = el.closest && el.closest('[data-media-slide]');
    if (!slide) return false;
    return !slide.classList.contains('is-selected') &&
           !slide.classList.contains('is-prev') &&
           !slide.classList.contains('is-next');
  }

  Object.defineProperty(HTMLImageElement.prototype, 'src', {
    set: function(value) {
      if (_active && value && isOffSlide(this)) {
        this.dataset.intSrc = value;
        return;
      }
      _origSrc.set.call(this, value);
    },
    get: _origSrc.get,
    configurable: true
  });

  Element.prototype.setAttribute = function(name, value) {
    if (_active && name === 'src' && this.tagName === 'IMG' && value && isOffSlide(this)) {
      this.dataset.intSrc = value;
      return;
    }
    _origSetAttr.call(this, name, value);
  };

  document.addEventListener('int:via:data:ready', function() { _active = true; });
  document.addEventListener('int:gallery:settled',    function() { _active = false; });

  document.addEventListener('page:load',  function() { _active = false; });
  document.addEventListener('theme:load', function() { _active = false; });
})();

;

/* INT: First-load native gallery src strip for iOS — framed prints + apparel */
(function() {
  if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) return;
  function stripNativeGallery() {
  var slideshow = document.querySelector('[data-product-slideshow]');
  if (!slideshow) return;
  var allSlides = slideshow.querySelectorAll('[data-media-slide]');
  var slideIndex = 0;
  var keepCount = 3; /* match pre-parse guard — keep first 3 decoded */
  var slideMap = {};
  allSlides.forEach(function(s, i) { slideMap[s.dataset.mediaId || i] = i; });
  slideshow.querySelectorAll(
    '[data-media-slide]:not(.is-selected):not(.is-prev):not(.is-next) img'
  ).forEach(function(img) {
    if (img.dataset.fpSrc) return; /* fp lazy imgs manage their own lifecycle */
    /* Keep first 3 slides with src for instant thumbnail access */
    var slide = img.closest('[data-media-slide]');
    if (slide) {
      var idx = Array.prototype.indexOf.call(allSlides, slide);
      if (idx >= 0 && idx < keepCount) return;
    }
    if (img.src && img.src !== '') {
      if (!img.dataset.intSrc) img.dataset.intSrc = img.src;
      img.src = '';
    }
    if (img.srcset) { img.dataset.intSrcset = img.srcset; img.srcset = ''; }
  });
}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripNativeGallery);
  } else {
    stripNativeGallery();
  }
  /* `__intVIADataReady` was set by the VIA app; nothing sets it now, so these
     re-runs were already unconditional. */
  setTimeout(stripNativeGallery, 800);
  setTimeout(stripNativeGallery, 2000);
})();

;

/* INT: Release off-screen decoded image memory on iOS after VIA settle */
(function() {
  if (!/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) return;

  function releaseIdleSlides() {
    var allSlides = document.querySelectorAll('[data-product-slideshow] [data-media-slide]');
    document.querySelectorAll(
      '[data-product-slideshow] [data-media-slide]:not(.is-selected):not(.is-prev):not(.is-next)'
    ).forEach(function(slide) {
      /* Keep first 3 slides loaded for instant thumb access */
      var idx = Array.prototype.indexOf.call(allSlides, slide);
      if (idx >= 0 && idx < 3) return;
      slide.querySelectorAll('img[src]:not([src=""])').forEach(function(img) {
        if (img.dataset.fpSrc) return; // fp lazy images manage their own lifecycle
        if (!img.dataset.intSrc) img.dataset.intSrc = img.src;
        img.src = '';
        img.loading = 'lazy';
      });
    });
  }

  function restoreSlide(slide) {
    slide.querySelectorAll('img[data-int-src]').forEach(function(img) {
      if (img.dataset.fpSrc) return; // fp lazy images manage their own src
      /* Skip if src already matches — prevents browser resetting complete=false
         on same-value writes when srcset is present (feedback loop breaker) */
      var currentSrc = img.getAttribute('src') || '';
      if (currentSrc === img.dataset.intSrc) return;
      img.src = img.dataset.intSrc;
      img.loading = 'eager';
      if (img.dataset.intSrcset) img.srcset = img.dataset.intSrcset;
    });
  }

  var _releaseSlideshow = null;
  var _slideSelObs = null;

  function setupRelease() {
    if (_slideSelObs) { _slideSelObs.disconnect(); _slideSelObs = null; }

    var slideshow = document.querySelector('[data-product-slideshow]');
    if (!slideshow) return;

    _releaseSlideshow = slideshow;

    /* Persistent MO — catches every Flickity slide transition via class change,
       regardless of whether 'select' event fires before or after class update */
    var _restoreDebounce = null;
    _slideSelObs = new MutationObserver(function(mutations) {
      var needsRestore = null;
      for (var _mi = 0; _mi < mutations.length; _mi++) {
        var mut = mutations[_mi];
        if (mut.attributeName === 'class' &&
            mut.target.dataset &&
            mut.target.dataset.mediaSlide !== undefined &&
            mut.target.classList.contains('is-selected')) {
          needsRestore = mut.target;
        }
      }
      if (needsRestore && !_restoreDebounce) {
        restoreSlide(needsRestore);
        _restoreDebounce = setTimeout(function() {
          _restoreDebounce = null;
          releaseIdleSlides();
        }, 400);
      }
    });
    _slideSelObs.observe(slideshow, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });

    if (window.__intCleanupRegistry) {
      window.__intCleanupRegistry.push(function() { _slideSelObs.disconnect(); });
    }

    /* Restore currently selected slide immediately */
    var currentSel = slideshow.querySelector('[data-media-slide].is-selected');
    if (currentSel) restoreSlide(currentSel);

    releaseIdleSlides();
  }

  var _setupReleaseTimer = null;
document.addEventListener('int:gallery:settled', function() {
  clearTimeout(_setupReleaseTimer);
  _setupReleaseTimer = setTimeout(setupRelease, 600);
});

  if (window.__intCleanupRegistry) {
    window.__intCleanupRegistry.push(function() {
      _releaseSlideshow = null;
      document.querySelectorAll('[data-media-slide] img[data-int-src]').forEach(function(img) {
        img.removeAttribute('data-int-src');
        img.removeAttribute('data-int-srcset');
      });
    });
  }
})();
